export type ClientOrigin = "Onshore" | "Offshore" | "Prospect On" | "Prospect Off";
export type ClientType =
  | "MFO" | "SFO" | "Endowment" | "Hedge Fund" | "Private Bank"
  | "High-Networth Individual" | "Asset Manager" | "Pension Fund" | "FoF" | "Foundation";
export const CLIENT_ORIGINS: ClientOrigin[] = ["Offshore", "Onshore", "Prospect Off", "Prospect On"];
export const CLIENT_TYPES: ClientType[] = [
  "Asset Manager", "Endowment", "FoF", "Foundation", "Hedge Fund",
  "High-Networth Individual", "MFO", "Pension Fund", "Private Bank", "SFO",
];
export interface Client {
  id: string;
  name: string;
  origin: ClientOrigin;
  type: ClientType;
  person_of_contact: string[];
  role: string | null;
  email: string[];
  phone: string[];
  observacoes: string[];
  address: string | null;
  responsavel_jusc: string;
  created_at: string;
  updated_at: string;
}
export interface Fund {
  id: string;
  name: string;
  start_date: string | null;
  investment_period_end: string | null;
  usdbrl_rate: number | null;
  irr: number | null;
  average_tenor: number | null;
  created_at: string;
  updated_at: string;
}
export interface FundAsset {
  id: string;
  fund_id: string;
  asset_name: string;
  thesis: string | null;
  investment_date: string | null;
  acquisition_cost: number | null;
  capital_received: number | null;
  future_receivables: number | null;
  future_asset_value: number | null;
  multiple: number | null;
  irr: number | null;
  first_payment_date: string | null;
  first_payment_value: number | null;
  last_payment_date: string | null;
  last_payment_value: number | null;
  average_tenor: number | null;
  structure: "True Sale" | "Structured" | "Investment" | "Other" | null;
  upfront_amount: string | null;
  other_details: string | null;
  feeder: string | null;
  created_at: string;
  updated_at: string;
}
export interface FundAssetCashflow {
  id: string;
  fund_asset_id: string;
  year: number;
  amount: number | null;
  received: boolean;
  created_at: string;
  updated_at: string;
}
// v2: NORMALIZADO. Cada linha = uma alocação (client, fund) → BRL+USD.
export interface Investment {
  id: string;
  client_id: string;
  fund_id: string;
  amount_brl: number;
  amount_usd: number;
  created_at: string;
  updated_at: string;
}
export interface Interaction {
  id: string;
  client_id: string;
  interaction_date: string | null;
  poc_jus: string | null;
  poc_investor: string | null;
  backlog: string | null;
  task: string | null;
  deadline: string | null;
  task_completed: boolean;
  created_at: string;
  updated_at: string;
}
export interface InteractionAttachment {
  id: string;
  interaction_id: string | null;
  original_name: string;
  content_type: string;
  size_bytes: number;
  created_at: string;
}
export interface AuditLog {
  id: string;
  user_id: string | null;
  user_email: string | null;
  table_name: string;
  record_id: string;
  action: "INSERT" | "UPDATE" | "DELETE";
  old_data: Record<string, unknown> | null;
  new_data: Record<string, unknown> | null;
  created_at: string;
}
export interface UserPermissions {
  can_view_clients: boolean;
  can_view_investments: boolean;
  can_view_funds: boolean;
  can_view_assets: boolean;
  can_edit_clients: boolean;
  can_edit_funds: boolean;
  can_edit_assets: boolean;
}
export interface UserRow extends UserPermissions {
  id: string;
  email: string;
  display_name: string | null;
  approved: boolean;
  is_admin: boolean;
  created_at: string;
  last_login_at: string | null;
}
export interface MeResponse {
  user: {
    id: string;
    oid: string;
    email: string;
    name: string;
    isAdmin: boolean;
    isApproved: boolean;
  };
  permissions: UserPermissions;
}
// Chamada de capital de um fundo. percentage/amount_brl chegam como string
// (numeric do Postgres). amount_brl é derivado no backend — percentage sobre o
// Total (BRL) do fundo, que é SUM(investments.amount_brl + câmbio × amount_usd).
// Presente apenas na listagem (GET).
export interface CapitalCall {
  id: string;
  fund_id: string;
  call_number: number;
  call_date: string;
  percentage: string;
  amount_brl?: string;
  created_at: string;
  updated_at: string;
}
// Distribuição de capital de um fundo. Diferente da chamada, aqui o amount_brl
// é DIGITADO e armazenado (não derivado de percentual) — distribuição é retorno
// de capital + lucro, sem relação fixa com o committed. Chega como string
// (numeric do Postgres).
export interface CapitalDistribution {
  id: string;
  fund_id: string;
  distribution_number: number;
  distribution_date: string;
  amount_brl: string;
  created_at: string;
  updated_at: string;
}
